import { useEffect, useState } from 'react'
import theme from '../../config/styles/theme'
import { formatAmount } from '../../modules/utils/formatters'

/**
 * The Sankey's custom hook.
 */
const useSankeyChart = (data, type) => {
  const [serie, setSerie] = useState([])
  const colors = [
    theme.palette.charts.moodyBlue,
    theme.palette.charts.shadeBlue,
    theme.palette.charts.toryBlue,
    theme.palette.charts.jacksonsPurple,
    theme.palette.charts.moodyBlue,
    theme.palette.charts.shadeBlue,
    theme.palette.charts.toryBlue,
    theme.palette.charts.jacksonsPurple,
    theme.palette.charts.moodyBlue,
    theme.palette.charts.shadeBlue
  ]

  useEffect(() => {
    const setData = data => {
      const totalValue = data.reduce((a, b) => a + (b.amount || 0), 0)
      const totalBiddings = data.reduce((a, b) => a + (b.quantiyBiddings || 0), 0)
      const totalOrders = data.reduce((a, b) => a + (b.quantityOrders || 0), 0)

      /** Get the range of weight for each serie */

      const newArray = data.map((item, index) => ({
        color: colors[index],
        from:
          type === 1
            ? `Monto total de licitaciones: $${formatAmount(totalValue)}`
            : type === 2
              ? `Total de licitaciones: ${totalBiddings}`
              : type === 3
                ? `Total de órdenes de compra: ${totalOrders}`
                : null,
        to:
          type === 1
            ? `${item.name}: $${formatAmount(item.amount)}`
            : type === 2
              ? `${item.name}: ${item.quantiyBiddings}`
              : type === 3
                ? `${item.name}: ${item.quantityOrders}`
                : null,
        weight:
          type === 1
            ? (item.amount * data.length) / totalValue
            : type === 2
              ? (item.quantiyBiddings * data.length) / totalBiddings
              : type === 3
                ? (item.quantityOrders * data.length) / totalOrders
                : null
      }))
      setSerie(newArray)
    }
    setData(data)
  }, [data])

  return { serie }
}

export default useSankeyChart
